import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component'
import { Gallery } from '../../interfaces/api/Gallery'
import { getStatusColor } from '../../interfaces/api/GalleryStatus'


@Component({
  selector: 'app-header-newgalleries',
  templateUrl: './header-newgalleries.component.html',
  styleUrl: './header-newgalleries.component.scss',
  standalone: true,
  imports: [ CommonModule, TranslateModule,
          ConfirmModalComponent ]
})
export class HeaderNewgalleriesComponent {
    @Input() gallery: Gallery;
  isConfirmModalOpen: boolean = false;

  constructor(private router: Router) {}

  goToList() {
    this.router.navigate(['/my-galleries']);
  }

  openConfirmModal(): void {
    this.isConfirmModalOpen = true;
  }

  closeConfirmModal(): void {
    this.isConfirmModalOpen = !this.isConfirmModalOpen;
  }

  goBack() {
      if (this.gallery.id) {
          this.goToList();
      } else {
          this.openConfirmModal();
      }
  }

    protected readonly getStatusColor = getStatusColor
}
